import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, ChangeDetectorRef, Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { DataViewModule } from 'primeng/dataview';
import { ProductService } from '../../services/product.service';
import { RatingModule } from 'primeng/rating';
import { FormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { GeneralEmitterService } from '../../services/general-emitter.service';
import { CartDetailComponent } from '../../components/cart-detail/cart-detail.component';
import { CartOptionsComponent } from '../../components/cart-options/cart-options.component';
import { StepperComponent } from '../../components/stepper/stepper.component';
import { CartOrderFlowComponent } from '../../components/cart-order-flow/cart-order-flow.component';
import { SpinnerComponent } from '../../components/spinner/spinner.component';
import { MercadoPagoService } from '../../services/mercado-pago.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { OrderPaymentProcessService } from '../../services/order-payment-process.service';
import { OrdersService } from '../../services/orders.service';
import { switchMap } from 'rxjs';

@Component({
  selector: 'app-cart',
  standalone: true,
  imports: [CartDetailComponent, 
    HeaderComponent,
    FooterComponent,
    CartOptionsComponent,
    StepperComponent,
    CartOrderFlowComponent,
    SpinnerComponent
  ],
  templateUrl: './cart.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  styleUrl: './cart.component.scss'
})
export class CartComponent {
  public indexView: number = 1;
  public labels = ['Revisión de solicitud', 'Realizar Pago', 'En proceso de envío', 'Entregado']
  urlParams: any = {};
  preferenceId = '';
  public estado: string | null = '';
  usr: any = localStorage.getItem('usr') || '';

  constructor(private mpService: MercadoPagoService,
      private route: ActivatedRoute,
      private router: Router,
      private http: HttpClient,
      private cdf: ChangeDetectorRef,
      private orderPaymentProcessService: OrderPaymentProcessService,
      private orderStatus: OrdersService
    ) { }
  
  ngOnInit() {
    this.usr = localStorage.getItem('usr') || '';
    //  https://s6pb58kf-4200.usw3.devtunnels.ms/cart/?collection_id=179964600797&collection_status=in_process&payment_id=179964600797&status=in_process&external_reference=0001&payment_type=debit_card&merchant_order_id=44749832311&preference_id=2211765310-906ea4cb-dda9-4ba7-a874-df3ba8545b32&site_id=MLM&processing_mode=aggregator&merchant_account_id=null
    this.route.paramMap.subscribe(params => {
      this.estado = params.get('estado'); // approved, failed o pendin
    });
     const params = this.route.snapshot.queryParamMap;
    const paymentId = params.get('payment_id');
    console.log('paymentId :', paymentId);

     const keys = this.route.snapshot.queryParamMap.keys;

    // 2. Mapear cada llave a un objeto con su clave y valor
    this.urlParams = keys.reduce((acc, key) => {
      acc[key] = this.route.snapshot.queryParamMap.get(key);
      return acc;
    }, {} as Record<string, string | null>);

    console.log('Todas las llaves:', keys);
    console.log('Objeto completo de parámetros:', this.urlParams);


    
    if ( paymentId ) {
      this.clearUrlParams();
      this.checkPaymentStatus(this.urlParams.payment_id);
      this.indexView = 2;
      this.router.navigate(['/cart']);
      this.cdf.detectChanges();
    }
  }
  setProcessView(ix: any) {
    this.indexView = ix.option;
    if ( this.estado ) {
      this.indexView = 2;
    }
  }

  checkPaymentStatus(paymentId: string) {
    this.mpService.getPaymentStatusValue(paymentId).subscribe({
      next: async (payment) => {
        await this.updatePaymentStatus(payment);
        console.log('Estado del pag **** o:', payment);
      },
      error: () => console.log('Error al obtener el estado del pago')
      // next: payment => this.showPaymentStatus(payment.status, payment.statusDetail),
      // error: () => this.showPaymentStatus('unknown')
    });
  }

  updatePaymentStatus(paymentData: any) {
    let { preference_id } = this.urlParams;
    let payload = {
      status: paymentData.status,
      status_detail: paymentData.status_detail,	
      lastCard: paymentData.lastCard,
      shippingCost: paymentData.shippingCost,
      paymentId: paymentData.paymentId,
      processDate: paymentData.processDate,
      lastUpdateDate: paymentData.lastUpdateDate,
      approvedDate: paymentData.approvedDate

    };
    
    this.orderPaymentProcessService
    .updatePaymentProcess(preference_id, payload)
    .pipe(
      switchMap(paymentProcess => {
      console.log('paymentProcess :', paymentProcess);
        const payloadOrder = {
          orderId: paymentProcess.data.order_id,
          usr:  this.usr,
          status: paymentData.status === 'approved' ? 'Preparando Envío' : 'Cotización Aceptada',
          status_payment: paymentProcess.data.status,
          paymentId: paymentProcess.data.paymentId
        };

        return this.orderStatus.updateOrderStatus(payloadOrder);
      })
    )
    .subscribe({
      next: orderResponse => {
        console.log('Pago y orden actualizados:', orderResponse);
      },
      error: error => {
        console.error('No se pudo actualizar el pago o la orden:', error);
      }
    });

    // this.orderPaymentProcessService.updatePaymentProcess(preference_id, payload).subscribe({
    //   next: payment => {
    //     console.log('Estado del pago actualizado:', payment);
    //     let payloadOrder = {
    //       orderId: payment.orderId,
    //       usr: localStorage.getItem('usr') || '',
    //       status: 'Procesando',
    //       status_payment: payment.status // Cambia esto según la lógica de tu aplicación
    //     }
    //     this.orderStatus.updateOrderStatus(payloadOrder).subscribe({
    //       next: payment => {
    //         console.log('Estado del pago actualizado:', payment);
    //       },
    //       error: () => console.log('Error al actualizar el estado del pago')
    //     });
    //   },
    //   error: () => console.log('Error al actualizar el estado del pago')
    // });
    
  }

  clearUrlParams() {
    if ( this.urlParams.payment_id ) {
      this.router.navigate([], {
        queryParams: {
          token: null,
          id: null,
          collection_id: null,
          collection_status: null,
          payment_id: null,
          status: null,
          external_reference: null,
          payment_type: null,
          merchant_order_id: null,
          preference_id: null,
          site_id: null,
          processing_mode: null,
          merchant_account_id: null,
        },
        queryParamsHandling: 'merge', // Mantiene otros parámetros si existieran
        replaceUrl: true // Reemplaza el historial para que el usuario no vuelva a verlos al dar "Atrás"
      });
    }
  }
}
